<template>
  <div class="message">
    <div
      class="page-section"
      v-loading="listLoading"
      :element-loading-text="$t('common.requestLoading')"
      element-loading-spinner="el-icon-loading"
    >
      <div class="message-empty" v-if="listData.length === 0">{{ $t('message.comeVisa.empty') }}</div>
      <div
        class="message-item"
        v-for="item in listData"
        :key="item.id"
        @click="setMessageToRead(item)"
      >
        <div class="message-item__info">
          <p class="message-item__title" :class="{ new: item.readState == 'UN_READ' }">{{ $t('message.comeVisa.title') }}</p>
          <p class="message-item__desc">{{item.content}}</p>
        </div>
        <el-button type="text" @click.stop="goToDetail(item)">{{ $t('message.comeVisa.viewButton') }}</el-button>
      </div>
      <div class="page-pagination" v-if="listInfo.totalCount > listInfo.pageSize">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="getMessageData"
          :current-page="listInfo.pageNo"
          :total="listInfo.totalCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as messageApi from '@/apis/message'
export default {
  name: 'comeVisaMessage',
  data() {
    return {
      listData: [],
      listInfo: {
        pageNo: 1,
        pageSize: 10,
        type: 'COMEVISA',
        totalCount: 0,
      },
      listLoading: false,
    }
  },
  activated() {
    this.getMessageData()
  },
  methods: {
    async getMessageData(pageNum = this.listInfo.pageNo) {
      this.listLoading = true
      try {
        this.listInfo.pageNo = pageNum
        const result = await messageApi.getMessageData(this.listInfo)
        this.listLoading = false
        if (result) {
          const { records, pageNum, totalCount } = result
          this.listData = records
          this.listInfo.pageNo = pageNum
          this.listInfo.totalCount = totalCount
        }
      } catch (err) {
        this.listLoading = false
      }
    },
    async setMessageToRead({ id, readState }) {
      if (readState == 'UN_READ') {
        try {
          const result = await messageApi.setMessageToRead(id)
          if (result) {
            this.getMessageData()
          }
        } catch (err) {
          throw new Error(err)
        }
      }
    },
    goToDetail() {},
  },
}
</script>
